import React, { FC } from 'react';
import { Tabs as AppKitTabs, Tab } from '@appkit4/react-components/tabs';
import './Tabs.scss';

export interface TabItem {
    label: string;
    icon?: string;
    value: string;
    variant?: string;
}

interface TabsProps {
    tabs: TabItem[];
    activeTab: number;
    onTabChange: (index: number, value: string) => void;
    className?: string;
}

const Tabs: FC<TabsProps> = ({ tabs, activeTab, onTabChange }) => {
    return (
        <div className="table-tabs">
            <AppKitTabs
                type="filled"
                stretched={true}
                activeIndex={activeTab}
                defaultActiveIndex={0}
                onTabChange={onTabChange}
                responsive
                showBothIndicators
            >
                {tabs.map((tab, index) => (
                    <Tab
                        key={index}
                        label={tab.label}
                        icon={tab.icon}
                        value={tab.value}
                        className={`${activeTab === index ? 'active' : ''} ${
                            tab.variant || 'default'
                        }`}
                    />
                ))}
            </AppKitTabs>
        </div>
    );
};

export default Tabs;
